<!--
  ~ Copyright (c) 2022 Certusoft, Inc. All Rights Reserved.
  ~
  ~ This SOURCE CODE FILE, which has been provided by Certusoft as part
  ~ of a Certusoft product for use ONLY by licensed users of the product,
  ~ includes CONFIDENTIAL and PROPRIETARY information of Certusoft.
  ~
  ~ USE OF THIS SOFTWARE IS GOVERNED BY THE TERMS AND CONDITIONS
  ~ OF THE LICENSE STATEMENT AND LIMITED WARRANTY FURNISHED WITH
  ~ THE PRODUCT.
  -->

<div>
    <h4 class="first-header">
        <label class="control-label">Clik Runtime Reference Name</label>: <span>{{ clikConfigurationName }}</span>
    </h4>
    <div class="row">
        <div class="col-xs-12 col-sm-4">
            <label for="project">Project</label>
            <select id="project" class="form-select" [(ngModel)]="info.projectName" (ngModelChange)="projectChange()">
                <option *ngFor="let option of options.projectOptions" value="{{ option.project_name }}">
                    {{ option.display_label }}
                </option>
            </select>
            <br />
            <label for="tag">Tag</label>
            <select id="tag" class="form-select" [(ngModel)]="info.tagName" (ngModelChange)="tagChange()">
                <option *ngFor="let option of options.tagOptions" value="{{ option.tag_name }}">
                    {{ option.display_label }}
                </option>
            </select>
        </div>
    </div>
</div>
